import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useParams, useNavigate, Link } from 'react-router-dom';
import ApiService from '../../../../services/api';
import '../../css/course_content.css'; 
import logo from '../../../../media/logo.png';
import Att from '../../../../media/attachment.png';
import play_lesson from '../../../../media/play_lesson.png';
import play_module from '../../../../media/play_module.png';
import play_exam from '../../../../media/play_exam.png';
import Time from '../../../../media/timer_2.png';
import { toast } from "react-toastify";
import { confirmToast } from '../../../app/components/confirmToast';
import parse from "html-react-parser";
import description from '../../../../media/description.png';
import goals from '../../../../media/goals.png';
import audience from '../../../../media/audience.png';
import structure from '../../../../media/structure.png';
import certificate from '../../../../media/certificate2.png';
import program from '../../../../media/program.png';
import review from '../../../../media/reviews.png';
import review2 from '../../../../media/reviews_red.png';
import teachers from '../../../../media/teachers.png';
import Red_Trophy from '../../../../media/red_trophy.png';
import Logo from '../../../../media/acta_logo_black.png';
import Facebook from '../../../../media/facebook.png';
import X from '../../../../media/twitter.png';
import Telegram from '../../../../media/telegram.png';
import Phone from '../../../../media/phone.png';
import Mail from '../../../../media/mail.png';
import PEC from '../../../../media/pec.png';
import IVA from '../../../../media/iva.png';
import Home from '../../../../media/home_red.png';
import Person from '../../../../media/person.png';
import Grey_Trophy from '../../../../media/grey_trophy.png';
import Fail from '../../../../media/fail.png';
import Complete from '../../../../media/complete.png';
import Timer from '../../../../media/timer_4.png';
import Score from '../../../../media/success_2.png';
import Questions from '../../../../media/play_exam_2.png';
import Timer2 from '../../../../media/timer_3.png';
import DOMPurify from "dompurify";




function CourseContent() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [course, setCourse] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [activeSection, setActiveSection] = useState("description");
  const [modules, setModules] = useState([]);
  const [selectedLesson, setSelectedLesson] = useState(null);

  const [timer, setTimer] = useState(0);
  const timerRef = useRef(null);
  const videoRef = useRef(null);
  const heartbeatRef = useRef(null);
  const [videoPercent, setVideoPercent] = useState(0);

  const [examStarted, setExamStarted] = useState(false);
  const [examQuestions, setExamQuestions] = useState([]);
  const [examAnswers, setExamAnswers] = useState({});
  const [examTimeLeft, setExamTimeLeft] = useState(null);
  const [examResult, setExamResult] = useState(null);
  const [examSubmitting, setExamSubmitting] = useState(false);
  const [examError, setExamError] = useState(null);
  const examSessionIdRef = useRef(null);

  const [visibleAttachmentsModule, setVisibleAttachmentsModule] = useState(null);
  const [attachments, setAttachments] = useState([]);

  const [canRateCourse, setCanRateCourse] = useState(false);

  const [ratingValue, setRatingValue] = useState(0);
  const [reviewComment, setReviewComment] = useState("");
  const [submittingReview, setSubmittingReview] = useState(false);
  const [certificateUrl, setCertificateUrl] = useState(null);
  const [reviewDone, setReviewDone] = useState(false);
  const lastTimeRef = useRef(0);
  const watchedRef = useRef(0);

  const [hasReviewed, setHasReviewed] = useState(false);
  const [canDownloadCertificate, setCanDownloadCertificate] = useState(false);
  const submitLockRef = useRef(false);

  const BASE_URL = window.env.BACKEND_BASE_URL;

  const [previousLesson, setPreviousLesson] = useState(null);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [selectedTeacher, setSelectedTeacher] = useState(null);

  const lessonPanelRef = useRef(null);

  const progressRef = useRef(0);
  const [animatedProgress, setAnimatedProgress] = useState(0);

  const [circleProgress, setCircleProgress] = useState(0);

  

  const toEmbedUrl = (url) => {
    if (!url) return "";

    if (url.includes("watch?v=")) {
      const id = url.split("watch?v=")[1].split("&")[0];
      return `https://www.youtube.com/embed/${id}`;
    }

    if (url.includes("youtu.be")) {
      const id = url.split("youtu.be/")[1];
      return `https://www.youtube.com/embed/${id}`;
    }

    return url;
    };


  const enrichModulesWithAttachments = async (modules) => {
    return Promise.all(
      modules.map(async (mod) => {
        const attRes = await ApiService.getAttachmentsByModule(mod.slug);
        return { ...mod, hasAttachments: attRes.length > 0 };
      })
    );
  };

  useEffect(() => {
  if (!slug) return;

      const fetchModules = async () => {
        try {
          
          const [modulesRes, courseRes, reviewRes,  myCoursesRes] = await Promise.all([
            ApiService.getModuleSequential(slug),
            ApiService.getCourse(slug),
            ApiService.getCourseReviews(slug),
            ApiService.getMyCourses()
          ]);


          const myCourse = myCoursesRes.find(
            c => String(c.slug) === String(slug)
          );

           if (!myCourse || !myCourse.frequentable) {
            navigate("/", { replace: true });
            return;
          }


          const modulesWithAttachments = await enrichModulesWithAttachments(modulesRes);

          setModules(modulesWithAttachments);
          setCourse({
            ...courseRes,
            total_progress: myCourse ? myCourse.total_progress : 0
          });
          setReviews(reviewRes);

          for (const mod of modulesWithAttachments) {
            if (mod.is_unlocked) {
              const firstLesson = mod.lessons.find(l => !l.is_locked);

              if (firstLesson) {
                const detail = await ApiService.getLessonDetail(firstLesson.id);

                setSelectedLesson({
                  ...firstLesson,
                  ...detail
                });

                break;
              }
            }
          }

        } catch (err) {
          if (err.response?.status === 403) navigate("/", { replace: true });
          else console.error(err);
        }
      };

      fetchModules();
}, [slug, navigate]);



  useEffect(() => {
    if (!selectedLesson || selectedLesson.exam || selectedLesson.media_file) return;
    ApiService.startLesson(selectedLesson.id).catch(console.error);
  }, [selectedLesson]);

  useEffect(() => {
    if (!selectedLesson) return;

  
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }

    const isTextLesson =
      !selectedLesson.media_file &&
      !selectedLesson.exam &&
      !selectedLesson.is_completed &&
      selectedLesson.reading_ok;

    if (!isTextLesson) return;

    setTimer(0);

    timerRef.current = setInterval(() => {
      setTimer(prev => prev + 1);
    }, 1000);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [selectedLesson]);

  useEffect(() => {
    if (!selectedLesson) return;

    const isTextLesson =
      !selectedLesson.media_file &&
      !selectedLesson.exam;

    if (
      isTextLesson &&
      !selectedLesson.reading_ok &&
      !selectedLesson.is_completed
    ) {
      markLessonCompleted(selectedLesson.id);
    }
  }, [selectedLesson]);

  useEffect(() => {
    if (!selectedLesson) return;

    const isExternalMedia =
      selectedLesson.media_file &&
      !selectedLesson.media_file.includes(BASE_URL);

    if (
      (selectedLesson.h5p_file || isExternalMedia) &&
      !selectedLesson.is_completed
    ) {
      markLessonCompleted(selectedLesson.id);
    }
  }, [selectedLesson]);

  useEffect(() => {
    if (!selectedLesson?.media_file) return;

    const video = videoRef.current;
    if (!video) return;

    watchedRef.current = 0;
    lastTimeRef.current = 0;

    const handleTimeUpdate = () => {
      const current = video.currentTime;

      const delta = current - lastTimeRef.current;

      
      if (delta > 0 && delta < 1.5) {
        watchedRef.current += delta;
      }

      lastTimeRef.current = current;

      const percent = (watchedRef.current / video.duration) * 100;
      setVideoPercent(Math.min(percent, 100));
    };

    const handleSeeked = () => {
      
      lastTimeRef.current = video.currentTime;
    };

    video.addEventListener("timeupdate", handleTimeUpdate);
    video.addEventListener("seeked", handleSeeked);

    return () => {
      video.removeEventListener("timeupdate", handleTimeUpdate);
      video.removeEventListener("seeked", handleSeeked);
    };
  }, [selectedLesson]);

  useEffect(() => {
    if (
      !selectedLesson ||
      selectedLesson.media_file ||
      selectedLesson.is_completed ||
      !selectedLesson.reading_ok
    ) {
      return;
    }

    if (timer >= selectedLesson.reading_time) {
      markLessonCompleted(selectedLesson.id);
    }
  }, [timer, selectedLesson]);

  const fetchAttachments = async (moduleSlug) => {
    try {
      const res = await ApiService.getAttachmentsByModule(moduleSlug);
      setAttachments(res);
      setVisibleAttachmentsModule(moduleSlug);
    } catch (err) {
      console.error(err);
    }
  };


  const syncCourseProgress = async () => {
    try {
      const myCourse = await ApiService.getMyCourse(slug); 

      console.log("API RESPONSE:", myCourse);

      if (myCourse) {
        setCourse(prev => ({
          ...prev,
          total_progress: myCourse.total_progress
        }));
      }
      console.log("progress:", course?.total_progress);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!course) return;

    let isMounted = true;

    const init = async () => {
      try {
        
        const certRes = await ApiService.getCertificate(course.id);

        const hasCertificate = !!certRes?.file;

        if (isMounted && hasCertificate) {
          setCertificateUrl(certRes.file);
        }

        
        const reviewRes = await ApiService.getMyReview(course.id);
        const hasReviewed = !!reviewRes;

        if (isMounted) {
          setHasReviewed(hasReviewed);
        }

        
        if (isMounted && course.total_progress === 100) {
          
          
          if (!hasCertificate) {
            setCanDownloadCertificate(true);
          } else {
            setCanDownloadCertificate(false);
          }

          
          if (!hasReviewed) {
            setCanRateCourse(true);
          } else {
            setCanRateCourse(false);
          }

        } else {
          
          setCanRateCourse(false);
          setCanDownloadCertificate(false);
        }

      } catch (err) {
        console.error("Errore init corso", err);
      }
    };

    init();

    return () => {
      isMounted = false;
    };
  }, [course]);


 const markLessonCompleted = async (lessonId) => {
    try {
      await ApiService.completedLesson(lessonId);
      syncCourseProgress();

      const oldLesson = selectedLesson;

      const res = await ApiService.getModuleSequential(slug);
      const enriched = await enrichModulesWithAttachments(res);

      setModules(enriched);

      for (const mod of res) {
        const updatedLesson = mod.lessons.find(l => l.id === lessonId);

        if (updatedLesson) {

          setSelectedLesson({
            ...updatedLesson,
            ...oldLesson,
            is_completed: true
          });

          break;
        }
      }

    } catch (err) {
      console.error(err);
    }
  };
  
 
 
  const selectLesson = async (lesson) => {

    if (lesson.is_locked || lesson.exam?.is_locked) {
      toast.error("Contenuto bloccato. Completa i requisiti del modulo.");
      return;
    }
    
    if (lesson.isExam) {
      setSelectedLesson(lesson);

      setExamStarted(false);
      setExamQuestions([]);
      setExamAnswers({});
      setExamTimeLeft(null);
      setExamResult(null);
      examSessionIdRef.current = null;

      setTimer(0);
      setVideoPercent(0);
      setMobileSidebarOpen(false);

      return;
    }


    const loadLesson = async () => {
      try {
        const lessonDetail = await ApiService.getLessonDetail(lesson.id);

        const fullLesson = {
          ...lesson,
          ...lessonDetail
        };

        setSelectedLesson(fullLesson);

      } catch (err) {
        if (err.response?.status === 403) {
          toast.error("Contenuto bloccato.");
          return;
        }

        console.error(err);
      }
    };


    if (examStarted) {
      confirmToast({
        message: "Sei sicuro di abbandonare l'esame? Il tentativo verrà inviato nello stato attuale.",
        confirmText: "Sì, invia",
        cancelText: "Continua esame",
        onConfirm: async () => {
          try {
            await submitExam();
          } finally {
            setExamStarted(false);
            setExamQuestions([]);
            setExamAnswers({});
            setExamTimeLeft(null);
            setExamResult(null);
            examSessionIdRef.current = null;

            await loadLesson();
          }
        }
      });

      return;
    }


    await loadLesson();

    setExamStarted(false);
    setExamQuestions([]);
    setExamAnswers({});
    setExamTimeLeft(null);
    setExamResult(null);
    examSessionIdRef.current = null;
    setTimer(0);
    setVideoPercent(0);
    setMobileSidebarOpen(false);
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (!examStarted) return;

      submitExam(); 

      e.preventDefault();
      e.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [examStarted]);

   useEffect(() => {
    return () => {
      if (examStarted) {
        submitExam();
      }
    };
  }, [examStarted]);



  const startExam = async (exam) => {
    if (!exam) return;
    try {
      const res = await ApiService.startExam(exam.id);
      examSessionIdRef.current = res.session_id;
      setExamQuestions(res.questions);
      setExamTimeLeft(res.time_limit_minutes * 60);
      setExamStarted(true);
      setExamAnswers({});
      setExamResult(null);
    } catch (err) { console.error(err); }
  };

  const handleAnswerChange = (questionId, choiceId) => {
    setExamAnswers(prev => ({ ...prev, [questionId]: choiceId }));
  };

  const submitExam = async () => {
    if (!examStarted) return;
     if (submitLockRef.current) return;
     submitLockRef.current = true;
    setExamSubmitting(true);
    try {
      const payload = {
        session_id: examSessionIdRef.current,
        answers: Object.entries(examAnswers).map(([questionId, choiceId]) => ({ question_id: parseInt(questionId), choice_id: choiceId }))
      };
      const res = await ApiService.submitExam(selectedLesson.exam.id, payload);
      setExamResult(res);
      setExamStarted(false);
      setExamTimeLeft(null);

      const resModules = await ApiService.getModuleSequential(slug);
      const enriched = await enrichModulesWithAttachments(resModules);
      setModules(enriched);

      setSelectedLesson(prev => prev && prev.exam ? { ...prev, exam: { ...prev.exam, is_completed: res.passed, user_score: res.score } } : prev);

      if (!res.passed) toast.error("Non hai superato l'esame. Devi ripeterlo per avanzare.");

      if (res.passed) {
      syncCourseProgress();
    }

    } catch (err) {
      console.error(err);
      setExamError('Errore durante l’invio dell’esame.');
    } finally {
      setExamSubmitting(false);
      submitLockRef.current = false;
    }
  };

  const sendVideoEvent = async (event, currentTime) => {
    if (!selectedLesson?.id || selectedLesson.exam || !selectedLesson.media_file) return;
    try {await ApiService.sendVideoEvent(selectedLesson.id, event, currentTime)} 
    catch (err) { console.error(err); }
  };

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !selectedLesson?.media_file) return;

    const percentRequired = selectedLesson.completed_video ?? 0;

    
    if (percentRequired === 0) {
      if (!selectedLesson.is_completed) {
        markLessonCompleted(selectedLesson.id);
      }
      return;
    }

    const completionThreshold = percentRequired / 100;

    const handlePlay = () => {
      sendVideoEvent("play", video.currentTime);

      heartbeatRef.current = setInterval(() => {
        const currentTime = video.currentTime;

        sendVideoEvent("heartbeat", currentTime);

        const percent = video.duration
          ? currentTime / video.duration
          : 0;

        setVideoPercent(percent * 100);

        if (
          percent >= completionThreshold &&
          !selectedLesson.is_completed
        ) {
          markLessonCompleted(selectedLesson.id);
        }
      }, 1000);
    };

    const handlePause = () => {
      sendVideoEvent('pause', video.currentTime);

      if (heartbeatRef.current) {
        clearInterval(heartbeatRef.current);
        heartbeatRef.current = null;
      }
    };

    const handleSeeked = () => {
      sendVideoEvent('seek', video.currentTime);
    };

    const handleEnded = () => {
      sendVideoEvent('pause', video.currentTime);
    };

    video.addEventListener('play', handlePlay);
    video.addEventListener('pause', handlePause);
    video.addEventListener('seeked', handleSeeked);
    video.addEventListener('ended', handleEnded);

    return () => {
      video.removeEventListener('play', handlePlay);
      video.removeEventListener('pause', handlePause);
      video.removeEventListener('seeked', handleSeeked);
      video.removeEventListener('ended', handleEnded);

      if (heartbeatRef.current) {
        clearInterval(heartbeatRef.current);
        heartbeatRef.current = null;
      }
    };
  }, [selectedLesson]);

  useEffect(() => {
    if (!examStarted) return;

    
    if (examTimeLeft == null) return;

    if (typeof examTimeLeft !== "number") return;

    if (examTimeLeft <= 0) return;

    const timeout = setTimeout(() => {
      setExamTimeLeft(prev => {
        if (typeof prev !== "number") return prev;

        if (prev <= 1) {
          submitExam();
          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearTimeout(timeout);
  }, [examTimeLeft, examStarted]);


  const renderStars2 = (rating, clickable = false) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      let starClass = "empty";
      if (i <= rating) starClass = "filled";
      else if (i - rating <= 0.5) starClass = "half";
      stars.push(
        <span
          key={i}
          className={`star ${starClass} ${clickable ? "clickable" : "disabled"}`}
          onClick={clickable ? () => setActiveSection("reviews") : null}
        >
          ★
        </span>
      );
    }
    return stars;
  };

  useEffect(() => {
    lessonPanelRef.current?.scrollTo({
      top: 0,
      behavior: "auto", 
    });
  }, [selectedLesson?.id]);

  useEffect(() => {
    if (!course || course.total_progress == null) return;

    const timer = setTimeout(() => {
      const start = progressRef.current;
      const end = course.total_progress;

      const duration = 800;
      const startTime = performance.now();

      const animate = (time) => {
        const elapsed = time - startTime;
        const progress = Math.min(elapsed / duration, 1);

        const ease = 1 - Math.pow(1 - progress, 3);

        setAnimatedProgress(Math.round(start + (end - start) * ease));

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          progressRef.current = end;
        }
      };

      requestAnimationFrame(animate);

    }, 800); 

    return () => clearTimeout(timer);

  }, [course?.total_progress]);

  useEffect(() => {
    if (!course || course.total_progress == null) return;

    const timer = setTimeout(() => {
      setCircleProgress(course.total_progress);
    }, 800);

    return () => clearTimeout(timer);
  }, [course?.total_progress]);


  const hasStatus =
    selectedLesson?.exam ||
    selectedLesson?.is_completed ||
    selectedLesson?.media_file ||
    selectedLesson?.reading_ok;

 

  if (!course) return null;

  


  const mediaFile = selectedLesson?.media_file;

  const isYoutube =
    mediaFile?.includes("youtube.com") ||
    mediaFile?.includes("youtu.be");

 
  
  return (
  <div className="containerx">
    <div className="coursex-header">
      <div className="coursex-left">
        <img src={logo} alt="Logo" className="coursex-logo" />
        <span className="coursex-text">ACTAFAD</span>
        <span className="coursex-title2">|</span>
        <h1 className="coursex-title">{course.title}</h1>
      </div>
      <div className="header-actions">

        <Link  to="/" style={{color:'white', textDecoration:'none'}}>
          <img src={Home} alt="" style={{ width: 24, height: 24, marginRight: 8 }} />
          <span>Abbandona corso</span>
        </Link>
        
        <div
          className="certificate-item"
          onClick={() => certificateUrl && window.open(certificateUrl, '_blank')}
          style={{ cursor: certificateUrl ? 'pointer' : 'default' }}
        >
          <img src={Red_Trophy} alt="attestato" style={{ width: 24, height: 24, marginRight: 8 }} />
          <span style={{ color: certificateUrl ? 'inherit' : '#696969' }}>
            {certificateUrl ? 'Visualizza Attestato' : 'Sblocca Attestato'}
          </span>
        </div>

      
        <div
        className={`certificate-item review-item ${
          hasReviewed || !canRateCourse ? "disabled" : ""
        }`}
        onClick={() => {
          if (!canRateCourse || hasReviewed) return;
          setPreviousLesson(selectedLesson);
          setSelectedLesson({ rateCourse: true });
          setRatingValue(0);
          setReviewComment("");
          setVisibleAttachmentsModule(null);
        }}
      >
        <img
          src={review2}
          alt="recensione"
          style={{ width: 24, height: 24, marginRight: 8 }}
        />

        <span
          style={{
            color: hasReviewed
              ? "#999999"
              : canRateCourse
              ? "#f9f9fb"
              : "#999999",
          }}
        >
          {hasReviewed
            ? "Valutazione effettuata"
            : canRateCourse
            ? "Valuta il corso"
            : "Sblocca valutazione"}
        </span>
      </div>

      </div>
    </div>
    <button
      className="mobile-course-menu-btn"
      onClick={() => setMobileSidebarOpen(true)}
    >
      ☰ Contenuti corso
    </button>
    <div className="page">
      <div className={`side-panel ${mobileSidebarOpen ? 'mobile-open' : ''}`}>
        <button
          className="close-mobile-sidebar"
          onClick={() => setMobileSidebarOpen(false)}
        >
          ✕
        </button>
        <div 
          className={`timer-panel ${hasStatus ? "has-status" : ""}`} 
          style={{"--progress": circleProgress}}
        >
          <h3><img src={Grey_Trophy} alt="progresso" style={{ width: 24, height: 24, marginRight: 8, marginTop: '-2.5px' }} />{animatedProgress} %</h3>
          {hasStatus && (
            <div className="status-message">
              {selectedLesson ? (
                selectedLesson.exam ? (
                  selectedLesson.exam.is_completed ? <p style={{color: '#4e8d42'}}><img src={Complete} alt="superato" style={{ width: 24, height: 24, marginRight: 8, marginTop: '-2.5px' }} />{Math.floor(selectedLesson.exam.user_score)}/ 100</p> :
                  examStarted ? (
                    selectedLesson.exam.time_limit_minutes == null ? (
                      <p><img src={Timer} alt="tempo" style={{ width: 24, height: 24, marginRight: 8, marginTop: '-2.5px' }}/>Illimitato</p>
                    ) : (
                      <p>
                        <img src={Timer} alt="tempo" style={{ width: 24, height: 24, marginRight: 8, marginTop: '-2.5px' }}/>{Math.floor(examTimeLeft / 60)}:
                        {String(examTimeLeft % 60).padStart(2,'0')}
                      </p>
                    )
                  ) :
                  examResult && !examResult.passed ? <p style={{color: '#8d4242'}}><img src={Fail} alt="fallito" style={{ width: 24, height: 24, marginRight: 8, marginTop: '-2.5px' }} />{Math.floor(selectedLesson.exam.user_score)}/ 100</p> :
                  <p></p>
                ) : selectedLesson.is_completed ? <p style={{color: '#4e8d42'}}><img src={Complete} alt="completata" style={{ width: 24, height: 24, marginRight: 8, marginTop: '-2.5px' }}/>Completata</p> :
                selectedLesson.media_file ? (
                  <p>Video completato: {Math.floor(videoPercent)}%</p>
                ) :
                selectedLesson.reading_ok ? (
                  <p>
                    <img src={Timer} alt="tempo" style={{ width: 24, height: 24, marginRight: 8, marginTop: '-2.5px' }}/> {
                      Math.floor(Math.max(0, selectedLesson.reading_time - timer) / 60)
                    }:{
                      String(Math.max(0, selectedLesson.reading_time - timer) % 60).padStart(2, "0")
                    }
                  </p>
                ) : null
              ) : <p></p>}
            </div>
          )}
        </div>

        <div className="module-panel">
          {modules.map(module => (
            <div key={module.id} className={`module-card ${!module.is_unlocked?'locked':''}`}>
              <div className="module-title-container">
                <h3 className="module-title">
                  <img src={play_module} alt={module.title} className="attachment-icons"/>
                  <span className="module-title-text">{module.title}</span>
                </h3>
              </div>
              <ul className="lession-list">
                {module.lessons.map(lesson => (
                  <li
                    key={lesson.id}
                    onClick={() => {
                      selectLesson(lesson);
                      setVisibleAttachmentsModule(null); 
                    }}
                    className={`lesson-item ${lesson.is_locked?'locked':''} ${lesson.is_completed?'completed':''} ${selectedLesson?.id===lesson.id?'selected':''}`}
                  >
                    <div className="lesson-title-container">
                      <h4 className="lesson-title">
                        <img src={play_lesson} alt={lesson.title} className="attachment-icons"/>
                        <span className="lesson-title-text">{lesson.title}</span>
                      </h4>
                      <div className="lesson-subinfo">
                        {lesson.reading_ok && (
                          <>
                            <img src={Time} alt={lesson.title} className="attachment-icons"/>
                            <span>Tempo minimo richiesto: {Math.floor(lesson.reading_time / 60)} min</span>
                          </>
                        )}
                      </div>
                    </div>
                  </li>
                ))}
                {module.exam && (
                  <li
                    onClick={() => {
                      selectLesson({
                        id: module.exam.id,
                        title: "Esame",
                        isExam: true,
                        exam: module.exam
                      });

                      setVisibleAttachmentsModule(null); 
                    }}
                    className={`lesson-item exam-item ${module.exam.is_locked ? 'locked' : ''} ${module.exam.is_completed ? 'completed' : ''} ${selectedLesson?.isExam && selectedLesson?.id === module.exam.id ? 'selected' : ''}`}
                  >
                    <div className="lesson-title-container">
                      <h4 className="lesson-title">
                        <img src={play_exam} alt="esame" className="attachment-icons"/>
                        <span className="lesson-title-text">Esame</span>
                      </h4>

                      <div className="lesson-subinfo">
                        {module.exam.time_limit_minutes != null && (
                          <>
                            <img src={Time} alt="tempo esame" className="attachment-icons"/>
                            <span>Tempo limite: {module.exam.time_limit_minutes} min</span>
                          </>
                        )}
                      </div>
                    </div>
                  </li>
                )}
                {module.hasAttachments && (
                    <li
                      className={`module-attachments ${
                        !module.is_unlocked ? "locked" : ""
                      }`}
                      onClick={() => {
                        if (!module.is_unlocked) return;
                        if (examStarted) {
                          confirmToast({
                            message: "Sei sicuro di abbandonare l'esame? Il tentativo verrà inviato nello stato attuale.",
                            confirmText: "Sì, invia",
                            cancelText: "Continua esame",
                            onConfirm: async () => {
                              await submitExam();
                              setExamStarted(false);
                              fetchAttachments(module.slug);
                            }
                          });
                          return;
                        }

                        fetchAttachments(module.slug);
                      }}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          fetchAttachments(module.slug);
                        }
                      }}
                    >
                      <img src={Att} alt="allegati" className="attachment-icons" />
                      <span className="module-attachments-link">Allegati</span>
                    </li>
                  )}
              </ul>
            </div>
          ))}
        </div>
        

      
      
      </div>
      <div className="lesson-panel" ref={lessonPanelRef}>
      {!visibleAttachmentsModule && selectedLesson?.title != null && (
        <h3></h3>
      )}
        
        {selectedLesson?.rateCourse && (
          <div className="lesson-content">
            <h4>Valuta il corso</h4>

            <div className="rating-stars2">
              {[1,2,3,4,5].map(i => (
                <span
                  key={i}
                  className={`star2 ${i <= ratingValue ? 'filled' : 'empty'}`}
                  onClick={() => setRatingValue(i)}
                >
                  ★
                </span>
              ))}
            </div>

            <textarea
              className='courseDetail-sectionContentDisplay-new'
              style={{ width: "100%", borderRadius: '24px', border: '2.5px solid #e0e0e0', boxShadow: '0 4px 15px rgba(0,0,0,0.08)', background:'#fff', height:"400px", resize:'none'}}
              placeholder="Lascia un commento"
              value={reviewComment}
              onChange={e => setReviewComment(e.target.value)}
            />
            <br/>

           <button
            className='cta-button'
            style={{ marginTop: "50px"}}
            disabled={submittingReview || ratingValue === 0}
            onClick={async () => {
              try {
                setSubmittingReview(true);
                await ApiService.submitReview(slug, ratingValue, reviewComment);
                setReviewDone(true);
                setHasReviewed(true);
                setCanRateCourse(false);
                setSelectedLesson(previousLesson);

              } catch (err) {
                toast.error('Errore durante l’invio della recensione.');
              } finally {
                setSubmittingReview(false);
              }
            }}
          >
            Invia
          </button>
          </div>
        )}
        {visibleAttachmentsModule && attachments.length > 0 ? (
          <div className="lesson-content">
            <h4>Allegati</h4>
            <p>Trova i file relativi a questa sezione come allegati a questo Modulo</p>
            <ul>
              {attachments.map(att => (
                <li key={att.id}>
                  <a href={att.file} className='attachments-display' target="_blank" rel="noopener noreferrer"><img src={Att}/>{att.file.split('/').pop()}</a>
                </li>
              ))}
            </ul>
          </div>
        ) : selectedLesson ? (
          <div className={`lesson-content ${
            selectedLesson?.media_file || selectedLesson?.scorm_entry_point ? "no-bg" : ""}`}>
            {selectedLesson ? (
              <>
                {(selectedLesson.h5p_file) ? (
                  <div style={{ height: "70vh", width: "100%" }}>
                    <iframe
                    src={`${BASE_URL}h5p/lesson_${selectedLesson.id}/index.html`}
                    title="H5P Player"
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none"
                    }}
                    allowFullScreen
                  />
                 </div>
                ) : selectedLesson.media_file && !isYoutube ? (
                  <div>
                    <video
                      ref={videoRef}
                      key={selectedLesson.id}
                      controls
                      className="lesson-video"
                      preload="metadata"
                      playsInline
                      controlsList="nodownload"
                      onContextMenu={e => e.preventDefault()}
                    >
                      <source src={selectedLesson.media_file} type="video/mp4" />
                      Il tuo browser non supporta il video.
                    </video>
                  </div>
                ) : selectedLesson.media_file ? (
                  <div>
                    <iframe
                      className="streaming-video"
                      src={toEmbedUrl(selectedLesson.media_file)}
                      title="Lesson video"
                       frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                ) : selectedLesson.text_content ? (
                  <div>
                    {parse(DOMPurify.sanitize(selectedLesson.text_content))}
                  </div>
                ) : (
                  <p></p>
                )}

                
                {selectedLesson.exam && !examStarted && !selectedLesson.exam.is_completed && (
                  <>
                  <div className="exam-cards">
                    <div className="exam-card">
                      <img src={Score} alt="punteggio" />
                      <h3>
                        Punteggio minimo richiesto
                        <br />
                        <br />
                        <p style={{fontWeight:'bold'}}>{selectedLesson.exam.min_score_to_pass}/100</p>
                      </h3>
                    </div>

                    <div className="exam-card">
                      <img src={Questions} alt="domande" />
                      <h3>
                        Numero domande
                        <br />
                        <br />
                        <p style={{fontWeight:'bold'}}>{selectedLesson.exam.num_questions}</p>
                      </h3>
                    </div>

                    <div className="exam-card">
                      <img src={Timer2} alt="tempo" />
                      <h3>
                        Tempo limite
                        <br />
                        <br />
                        <p style={{fontWeight:'bold'}}>{selectedLesson.exam.time_limit_minutes == null
                          ? 'Illimitato'
                          : `${selectedLesson.exam.time_limit_minutes} min`}</p>
                      </h3>
                    </div>
                  </div>

                  <div className="exam-button-container">
                    <button
                      className="cta-button2"
                      onClick={() => startExam(selectedLesson.exam)}
                    >
                      Inizia esame
                    </button>
                  </div>
                </>
                )}
                {examStarted && selectedLesson.exam && (
                  <div className="exam-container">
                    <form onSubmit={(e) => e.preventDefault()}>
                      {examQuestions.map((q, idx) => (
                        <div key={q.id} style={{ marginBottom: '1rem', padding: '1rem', borderRadius: '24px', border: '2.5px solid #e0e0e0', boxShadow: '0 4px 15px rgba(0,0,0,0.08)', background:'#fff' }}>
                          <p><strong>Domanda {idx+1}:</strong> {q.question_text}</p>
                          {q.choices.map(c => (
                            <label className='terms-checkbox2' key={c.id} style={{ display: 'flex', alignItems: 'center', marginTop: '0.5rem', marginBottom: '-10px' }}>
                              <input
                                type="radio"
                                name={`question_${q.id}`}
                                value={c.id}
                                checked={examAnswers[q.id] === c.id}
                                onChange={() => handleAnswerChange(q.id, c.id)}
                              /> <span style={{marginLeft: "10px"}}>{c.choice_text}</span>
                            </label>
                          ))}
                        </div>
                      ))}
                      <button
                        type="button"
                        className="cta-button2"
                        disabled={examSubmitting || submitLockRef.current}
                        onClick={submitExam}
                      >
                        Invia Risposte
                      </button>
                    </form>
                  </div>
                )}
                {selectedLesson.exam && !examStarted && selectedLesson.exam.is_completed && (
                  <p className="lesson-completed">✓ Esame superato con punteggio {Math.floor(selectedLesson.exam.user_score)}%</p>
                )}
              </>
            ) : (
              <p></p>
            )}
          </div>
        ) : <p></p>}
      </div>
    </div>
  </div>
);


}

export default CourseContent;